export default class DocumentPolicy
{
    static create(user)
    {
        return true;
    }

    static view(user, document)
    {
        return true;
    }

    static delete(user, document)
    {
        return user.id === document.uploaded_by;
    }

    static update(user, document)
    {
        return user.id === document.uploaded_by;
    }
}